<!--<div class="toggle-options">
  <button md-button class="mat-primary mat-raised-button" (click)="toggleMobileStepText()">Toggle MobileStepText</button>
  <button md-button class="mat-primary mat-raised" (click)="toggleVertical()">Toggle Vertical</button>
  <button md-button class="mat-primary mat-raised" (click)="toggleLinear()">Toggle Linear</button>
  <button md-button class="mat-primary mat-raised" (click)="toggleAlternative()">Toggle Alternative</button>
  <button md-button class="mat-primary mat-raised" (click)="showError()">Show error</button>
  <button md-button class="mat-primary mat-raised" (click)="clearError()">Clear error</button>
  <button md-button class="mat-primary mat-raised" (click)="showFeedback()">Show Feedback</button>
  <button md-button class="mat-primary mat-raised" (click)="clearFeedback()">Clear Feedback</button>
</div>-->
<ngx-loading [show]="loading" [config]="{ fullScreenBackdrop : true }"></ngx-loading>

<app-pulsemenu></app-pulsemenu>


<div  *ngIf="user && user.length>0 && vflag===1" style="min-height: 500px;">
<mat-horizontal-stepper linear #stepper >
  <mat-step >
    <ng-template matStepLabel>Select Date And Time</ng-template>
      <div class="container">
      <div class="card">
        <div class="card-header">
            <div class="row">
                <div class="col-12 text-left ">
                  <label  style="font-family: open sans;font-size: 18px">Today's Date: {{todaysdate | date:'MMM d y'}} </label>
                </div>
              </div>
              <div class="row">
                  <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 text-left ">
                      <label *ngIf="selectedslot!==undefined" color="dark" style="font-family: open sans;font-size:18px">Selected Slot: {{selectedslot}} </label>
                    </div>
                <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6   text-right ">
                  <label  style="color:#000">Change Date: </label>
                  <mat-form-field>
                      <input type="date" time="false" date="true" matInput name="dob" displayFormat="MMM DD YYYY"  min="{{todaysdate}}"  [(ngModel)]="datepicker.month"
                      [ngModelOptions]="{standalone: true}" (ngModelChange)="GetOtherTimeSlot()" >
                  </mat-form-field>
                     <mat-datepicker name="dob" id="dob" #myDatepicker></mat-datepicker>
                      </div>
              </div>
              <div class="row">
                  <div class="col-sm-12 col-md-4 col-lg-4 col-xl-4  text-center" >
                      <div (click)="scrollWin()">
                          <button *ngIf="selectedslot!==undefined" class="btn btn-success"
                           (click)="nextStep1(stepper)">Continue</button>
                        </div>
                    </div>
                  <div class="col-sm-12 col-md-8 col-lg-8 col-xl-8  text-left">
                    <label color="dark" style="font-family: open sans;font-size:20px">
                      Available Slots For: {{datepicker.month | date:'MMM d y'}}</label>
                  </div>
                </div>

               
        </div>
        <div class="card-body" style="margin-top:3%">
              <div class="row">
                  <div class="col-12 center text-center">
                      <div class='flex-container flex-center'   *ngIf='shedule && shedule.length > 0; else nodays' >
                         
                        <div  id='calendar-container' class='flex-container flex-column'
                          *ngIf="result && result.length>0 && inleave !== 1  ; else noshedule">
                          <div *ngFor="let num of num">
                            <div *ngFor="let clinic of clinic">
                                  <div style="color:#9b7455; margin-top: 40px" *ngIf="num.clinicid === clinic.id">
                                <b>Clinic Name: </b>{{clinic.name}}
                                </div>
                              </div>
                                <div class='flex-container flex-wrap '>
                            <div   *ngFor="let item of temparr">
                                <div  *ngIf="item.id === num.id">
                                  <div class='row'>
                                    <div class='col-sm-4 col-lg-4 col-xl-4 text-left'>
                               <div  class='calendar-days flex-container flex-center ' (click)="selectedTime(item.val, num.clinicid)" [ngClass]="{'booked': isAlreadySelected(item.val),'select': myselectedSelected(item.val), 'past': pastTime(item.val) }" >{{item.val | slice:0:10 }}</div>
                                  </div>
                                  </div>
                              </div>
                           </div>
                           </div>
                          </div>
                         </div>

                        </div>
                  </div>
                </div>

                <div *ngIf="inleave !== 1" class="row" style="margin-top: 20px">
                <div class="col-sm-12 col-lg-12 col-xl-12" style="margin-bottom:20px">
                  
                        <label class="booked1"></label> <label >Already Booked</label > 
               </div>
                <div class="col-sm-12 col-lg-12 col-xl-12">
                        
                              <label class="booked2"></label> <label >Selected Slot</label >
                </div>
                </div>
        </div>



      </div>
     </div>
    

  </mat-step>
  <mat-step >
    <ng-template matStepLabel>Add Your pet Detail</ng-template>

      <div class="container">
          <div class="card-header">
              <div class="row">
                <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6 text-left">
                    <label color="dark" style="font-family: open sans;font-size:20px">
                        Selected Date : {{datepicker.month | date:'MMM d y'}}</label>
                </div>
                <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6 text-right">
                    <label *ngIf="selectedslot!==undefined" color="dark" style="font-family: open sans;font-size:18px">Selected Slot: {{selectedslot}} </label>
                  </div>
                </div>

                </div>
                <div class="card-body" style="margin-top:3%" *ngIf="formdatastatus != 1; else formdata">
                  <div class="row" >
                    <div *ngIf="mypetList && mypetList.length > 0" class=" col-sm-12 col-md-5 col-lg-5 col-xl-5 text-center" style="margin-top: 55px">
                      <mat-select placeholder=" Select your pet"  [(ngModel)]="selectedpetid">
                        <mat-option *ngFor="let pet of mypetList" value={{pet.id}} [value]="data.id">
                            {{pet.pet_name}}</mat-option>
                      </mat-select>
                     
                    </div>
                    <div style="margin-top: 55px" *ngIf=" selectedpetid===undefined && mypetList && mypetList.length > 0"  class=" col-sm-12 col-md-2 col-lg-2 col-xl-2 text-center">
                      <label >Or</label>
                      </div>
                    
                   <div class=" col-sm-12 col-md-5 col-lg-5 col-xl-5 text-center" *ngIf="selectedpetid===undefined;else rof" style="margin-top: 55px">
                      <button class="btn btn-success" *ngIf="formdatastatus==0;"(click)="gotoFormstep()">Add Your Pet</button>
                    </div>
                  </div>
                </div>
                <div class="card-footer" >
                    <div (click)="scrollWin()">
                        <button *ngIf="(rofapp != undefined  || formdatastatus == 1)" class="btn btn-success"
                          (click)="nextStep2(stepper)">Continue</button>
                        <button class="btn btn-success3" (click)="back1(stepper)">Back</button>
                      </div>
                </div>
      </div>


  </mat-step>

  <mat-step >
    <ng-template matStepLabel>Payment</ng-template>
     <div class="container">
        <div class="card-header">
            <div class="row">
              <div class="col-sm-12 col-md-4 col-lg-4 col-xl-4 text-left">
                  <label color="dark" style="font-family: open sans;font-size:20px">
                      Selected Date : {{datepicker.month | date:'MMM d y'}}</label>
              </div>
              <div class="col-sm-12 col-md-4 col-lg-4 col-xl-4 text-right">
                  <label *ngIf="selectedslot!==undefined" color="dark" style="font-family: open sans;font-size:18px">Selected Slot: {{selectedslot}} </label>
                </div>
                <div class="col-sm-12 col-md-4 col-lg-4 col-xl-4 text-right">
                    <label *ngIf="selectedpmode!==undefined" color="dark" style="font-family: open sans;font-size:18px">Payment Mode: {{selectedpmode}} </label>
                  </div>
              </div>
          </div>
       
          <div class="row">
            <div class="col-12 text-center">
               <!-- <mat-radio-group [(ngModel)]="selectedpmode" > 
                   <!-- <mat-radio-button (click)='getAmount()' value="pay_at_clinic">Pay At Clinic</mat-radio-button> -->
                   <!-- <mat-radio-button (click)='getAmount()' value="razorpay">Razorpay</mat-radio-button>
                  </mat-radio-group>-->

                  <div>
                      <a style="color: #9b7544"> We are collecting only the Appointment Confirmation Fee (Rs. {{basiconsid}}) for confirming the appointment. 
                         Doctor's fees and any additional Treatment charges to be paid at the clinic on actuals. </a> <br>
                      <a style="color: #9b7544"> Payment Mode: Razorpay. </a>
                  </div>
            </div>
          </div>
          <div *ngIf="basiconsid">
          <b>  Consultation Fees: Rs. {{basiconsid}} </b>
          </div>
          <div class="card-footer">
              <div (click)="scrollWin()">
                  <button  class="btn btn-success"
                    (click)="bookAppointment(stepper)">Confirm Booking</button>
                  <button class="btn btn-success3" (click)="back2(stepper)">Back</button>
                </div>
          </div>
     </div>


  </mat-step>
  <mat-step >
    <ng-template matStepLabel>Confirmation</ng-template>

        <div class="container">
          <div class="row">
            <div class="col-12 text-center">
              <p style="color:#9b7544; overflow-wrap:break-word; font-style:open sans;
              font-size:20px">
              Appointment Booked Successfully  <mat-icon>done all</mat-icon>
            </p>
            </div>
            <div class="col-12 text-center">
              <button class="btn btn-success" routerLink="/manageprofile/appointment">Check Your Appointment Info</button>
            </div>
          </div>
        </div>
       
  </mat-step>
</mat-horizontal-stepper>
</div>


<div  *ngIf="user && user.length>0 && vflag===0"  style="min-height: 500px;">
<mat-horizontal-stepper linear #stepper >
    <mat-step >
        <ng-template matStepLabel>Select Date And Time</ng-template>

      <div class="container">
      <div class="card">
        <div class="card-header">
            <div class="row">
                <div class="col-12 text-left ">
                  <label  style="font-family: open sans;font-size: 18px">Today's Date: {{todaysdate | date:'MMM d y'}} </label>
                </div>
              </div>
              <div class="row">
                  <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 text-left ">
                      <label *ngIf="selectedslot!==undefined" color="dark" style="font-family: open sans;font-size:18px">Selected Slot: {{selectedslot}} </label>
                    </div>
                <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6   text-right ">
                  <label style="color:#000">Change Date</label>
                  <mat-form-field>
                      <input type="date" time="false" date="true" matInput name="dob" displayFormat="MMM DD YYYY"  min="{{todaysdate}}"  [(ngModel)]="datepicker.month"
                      [ngModelOptions]="{standalone: true}" (ngModelChange)="GetOtherTimeSlot()" >
                  </mat-form-field>
                     <mat-datepicker name="dob" id="dob" #myDatepicker></mat-datepicker>
                      </div>
              </div>
              <div class="row">
                  <div class="col-sm-12 col-md-4 col-lg-4 col-xl-4  text-center" >
                      <div (click)="scrollWin()">
                          <button *ngIf="selectedslot!==undefined" class="btn btn-success"
                           (click)="nvnextStep1(stepper)">Continue</button>
                        </div>
                    </div>
                  <div class="col-sm-12 col-md-8 col-lg-8 col-xl-8  text-left">
                    <label color="dark" style="font-family: open sans;font-size:20px">
                      Available Slot For: {{datepicker.month | date:'MMM d y'}}</label>
                  </div>
                </div>
        </div>
        <div class="card-body" style="margin-top:3%">
              <div class="row">
                  <div class="col-12 center text-center">
                      <div class='flex-container flex-center' *ngIf='shedule && shedule.length > 0; else nodays'>
                          <div  id='calendar-container' class='flex-container flex-column'
                          *ngIf="result && result.length>0 && inleave !== 1  ; else noshedule">
                          <div *ngFor="let num of num">
                              <div *ngFor="let clinic of clinic">
                                    <div style="color:#9b7455; margin-top: 40px" *ngIf="num.clinicid === clinic.id">
                                  <b>Clinic Name: </b>{{clinic.name}}
                                  </div>
                                </div>
                                <div class='flex-container flex-wrap '>
                                  <div   *ngFor="let item of temparr">
                                    <div  *ngIf="item.id === num.id">
                                        <div class='row'>
                                            <div class='col-sm-4 col-lg-4 col-xl-4 text-left'>
                                   <div class='calendar-days flex-container flex-center ' (click)="selectedTime(item.val, num.clinicid)" [ngClass]="{'booked': isAlreadySelected(item.val),'select': myselectedSelected(item.val), 'past': pastTime(item.val) }" >{{item.val | slice:0:10 }}</div>
                                            </div>
                                          </div>
                                  </div>
                               </div>
                           </div>
                          </div>
                         </div>
                     
                        </div>
                  </div>
                </div>
                <div class="row" style="margin-top: 20px">
                    <div class="col-sm-12 col-lg-12 col-xl-12" style="margin-bottom:20px">
                    
                        <label class="booked1"></label> <label >Already Booked</label> 
               </div>
                <div class="col-sm-12 col-lg-12 col-xl-12" style="margin-bottom:20px">
                         
                              <label class="booked2"></label> <label>Selected Slot</label >
                </div>
                </div>
        </div>

      </div>
     </div>
    </mat-step>
    <mat-step >
        <ng-template matStepLabel>Add Your Pet Detail</ng-template>
 
      <div class="container">
          <div class="card-header">
              <div class="row">
                <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6 text-left">
                    <label color="dark" style="font-family: open sans;font-size:20px">
                        Selected Date : {{datepicker.month | date:'MMM d y'}}</label>
                </div>
                <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6 text-right">
                    <label *ngIf="selectedslot!==undefined" color="dark" style="font-family: open sans;font-size:18px">Selected Slot: {{selectedslot}} </label>
                  </div>
                </div>

                </div>
                <div class="card-body" style="margin-top:3%" *ngIf="formdatastatus != 1; else formdata">
                  <div class="row" >
                    <div  style="margin-top: 55px" *ngIf="mypetList && mypetList.length > 0" class=" col-sm-12 col-md-5 col-lg-5 col-xl-5 text-center" >
                      <mat-select placeholder=" Select your pet"  [(ngModel)]="selectedpetid">
                        <mat-option *ngFor="let pet of mypetList" value={{pet.id}} [value]="data.id">
                            {{pet.pet_name}}</mat-option>
                      </mat-select>
                    </div>
                    <div  style="margin-top: 55px" *ngIf=" selectedpetid===undefined && mypetList && mypetList.length > 0" class=" col-sm-12 col-md-2 col-lg-2 col-xl-2 text-center">
                      <label >Or</label>
                      </div>
                   <div  style="margin-top: 55px" class=" col-sm-12 col-md-5 col-lg-5 col-xl-5 text-center" *ngIf="selectedpetid===undefined;else rof">
                      <button class="btn btn-success" *ngIf="formdatastatus==0;"(click)="gotoFormstep()">Add Your Pet</button>
                    </div>
                  </div>
                </div>
                <div class="card-footer">
                    <div (click)="scrollWin()">
                        <button *ngIf="(rofapp != undefined  || formdatastatus == 1)" class="btn btn-success"
                          (click)="verifyMobile(stepper)">Continue</button>
                        <button class="btn btn-success3" (click)="nvback1(stepper)">Back</button>
                      </div>
                </div>
      </div>

    </mat-step>

    <mat-step >
        <ng-template matStepLabel>Verify Mobile</ng-template>
    
            <div class="row">
              <div class="col-12 text-center">
                <p style="font-style: open sans; color:#9b7544;font-size:20px; overflow-wrap:break-word">
                  Otp Has Been Sent To Your Mobile Number
                </p>
              </div>
            </div>
            <div class="row">
                <div class="col-12 text-center">
                 <div class="form-group">
                   <label>Enter OTP</label>
                   <input type="text" [(ngModel)]="tempdata">
                 </div>
                </div>
              </div>
              <div class="col-12 text-center">
                  <div class="form-group">
                  <button *ngIf="tempdata" class="btn btn-success" (click)="postForOtp(stepper)">Confirm</button>
                  </div>
                 </div>
    </mat-step>
    <mat-step >
        <ng-template matStepLabel>Payment</ng-template>
 
     <div class="container">
        <div class="card-header">
            <div class="row">
              <div class="col-sm-12 col-md-4 col-lg-4 col-xl-4 text-left">
                  <label color="dark" style="font-family: open sans;font-size:20px">
                      Selected Date : {{datepicker.month | date:'MMM d y'}}</label>
              </div>
              <div class="col-sm-12 col-md-4 col-lg-4 col-xl-4 text-right">
                  <label *ngIf="selectedslot!==undefined" color="dark" style="font-family: open sans;font-size:18px">Selected Slot: {{selectedslot}} </label>
                </div>
                <div class="col-sm-12 col-md-4 col-lg-4 col-xl-4 text-right">
                    <label *ngIf="selectedpmode!==undefined" color="dark" style="font-family: open sans;font-size:18px">Payment Mode: {{selectedpmode}} </label>
                  </div>
              </div>
          </div>

          <div class="row">
            <div class="col-12 text-center">   
               <!-- <md-radio-group [(ngModel)]="selectedpmode"> Select payment option
                 <!--   <md-radio-button value="pay_at_clinic">Pay At Clinic</md-radio-button>-->
                  <!--  <md-radio-button value="razorpay">Razorpay</md-radio-button>
                  </md-radio-group>-->
                  <div >
                      <a style="color: #9b7544">  We are collecting only the Appointment Confirmation Fee (Rs. {{basiconsid}}) for confirming the appointment. 
                        Doctor's fees and any additional Treatment charges to be paid at the clinic on actuals. </a> <br>
                      <a style="color: #9b7544"> Payment Mode: Razorpay. </a>
                  </div>
                 
            </div>
          </div>
          <div class="card-footer">
              <div (click)="scrollWin()">
                  <button  class="btn btn-success"
                    (click)="bookAppointment(stepper)">Confirm Booking</button>
                  <button class="btn btn-success3" (click)="nvback2(stepper)">Back</button>
                </div>
          </div>
     </div>
    </mat-step>
    <mat-step >
        <ng-template matStepLabel>Confirmation</ng-template>

        <div class="container">
          <div class="row">
            <div class="col-12 text-center">
              <p style="color:#9b7544; overflow-wrap:break-word; font-style:open sans;
              font-size:20px">
              Appointment Booked Successfully  <mat-icon>done all</mat-icon>
            </p>
            </div>
            <div class="col-12 text-center">
              <button class="btn btn-success" routerLink="/manageprofile/appointment">Check Your Appointment Info</button>
            </div>
          </div>
        </div>
    </mat-step>
</mat-horizontal-stepper>
</div>
<ng-template #selectslot>
    <label color="#9b7544" style=" font-family: open sans">Select Any Slot</label>
   </ng-template>
   <ng-template #noshedule>
      <div class="row">
        <div class="col-12 center text-center">
            <label color="dark" style=" font-family: open sans; font-size: 20px">Doctor is on leave. Please select a different date</label>
        </div>
      </div>
    </ng-template>
    <ng-template #nodays>
        <div class="row">
          <div class="col-12 center text-center">
              <label color="dark" *ngIf='shedule && shedule.length == 0 && check == 1' style=" font-family: open sans; font-size: 20px">No Schedule Available for this day</label>
          </div>
        </div>
      </ng-template>
      <ng-template #rof>
          <mat-select placeholder="Reason of Appointment"  [(ngModel)]="rofapp" style="margin-top: 55px; margin-left: 95px">
              <mat-option  *ngFor=" let service of servicedetail" value={{service.id}}>
                  {{service.name}}</mat-option>
            </mat-select>
      </ng-template>
     <ng-template #formdata>
       <div class="row" *ngIf="formdatastatus == 1">
         <div class="col-sm-12 col-md-4 col-lg-4 col-xl-4 text-center">
          <label>Pet's name: {{formdataname}}</label>
         </div>
         <div class="col-sm-12 col-md-4 col-lg-4 col-xl-4 text-center">
           <label> Pet's type: {{formdatatype}}</label>
          </div>
          <div class="col-sm-12 col-md-4 col-lg-4 col-xl-4 text-center">
            <div *ngFor=" let service of servicedetail">
            <div *ngIf="service.id == rofapp"  >
                <label>Reason: {{service.name}}</label>
            </div>
            </div>
            </div>
       </div>
     </ng-template>
